import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { FciListaRequest } from '../../requests/motor-fiscal/fci-lista.request';
import { GetAllFciResponse } from '../../responses/motor-fiscal/get-all-fci.response';
import { GetFciByIdResponse } from '../../responses/motor-fiscal/get-fci-by-id.response';
import { CriarFciRequest } from '../../requests/motor-fiscal/criar-fci.request';
import { CriarFciResponse } from '../../responses/motor-fiscal/criar-fci.response';
import { ExportarFciRequest } from '../../requests/motor-fiscal/exportar-fci.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class FciService extends CommonService {
  private readonly apiUrl: string = environment.urlApiMotorFiscal + 'Fci';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(request: FciListaRequest): Observable<GetAllFciResponse> {
    let params = new HttpParams();
    if (request.mes != null) params = params.set('mes', request.mes);
    if (request.ano != null) params = params.set('ano', request.ano);
    if (request.pagina != null) params = params.set('pagina', request.pagina);
    if (request.tamanhoPagina != null) params = params.set('tamanhoPagina', request.tamanhoPagina);

    return this.httpClient
      .get<GetAllFciResponse>(this.apiUrl, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  public getById(idFci: number): Observable<GetFciByIdResponse> {
    return this.httpClient
      .get<GetFciByIdResponse>(`${this.apiUrl}/${idFci}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public criar(request: CriarFciRequest): Observable<CriarFciResponse> {
    return this.httpClient
      .post<CriarFciResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public atualizar(idFci: number, request: CriarFciRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/${idFci}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluir(idFci: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/${idFci}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public exportar(idFci: number, empresa: ExportarFciRequest): Observable<Blob> {
    const { headers } = this.addHeaderToken();
    return this.httpClient
      .post(`${this.apiUrl}/${idFci}/exportar`, empresa, { headers, responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }
}
